<template lang="pug">
  .video-chat-faqs.fixed-width-tweak-upper
    h3.text-center.f-secondary.xs-f-large.md-f-xxlarge.lg-f-xlarge(v-if="title") {{ title }}
    accordion
      template(v-slot="{ selected, select }")
        accordion-section(
          v-for="(faq, index) in faqs"
          :key="index"
          :selected="selected"
          @select="select"
          :question="faq.question"
          :answer="faq.answer"
        )
</template>

<script>
  import Accordion from '@components/Accordion/Accordion';
  import AccordionSection from '@components/Accordion/AccordionSection.vue';

  export default {

    name: 'VideoChatFaqs',

    components: {
      Accordion,
      AccordionSection,
    },

    props: {
      title: {
        type: String,
        default: undefined,
      },

      faqs: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<style lang="stylus">
  .video-chat-faqs
    padding-top 1em
    padding-bottom 2em
</style>